import * as React from "react";
import { withTranslation } from 'react-i18next';

class TiendaNubeConnectButtonClass extends React.Component {

    render() {
        const { t } = this.props;
        return <button className="btn tiendanube" onClick={this.props.onClick} disabled={this.props.disabled}>{this.renderTiendaNubeLogo()}{t('tienda_nube_link.connect_tienda_nube')}</button>
    }

    getImage() {
        return "http://cdn.mcauto-images-production.sendgrid.net/a8ac5f98aef36b5c/1e3d5a4f-5579-4488-8367-f1ea4df33a79/640x480.png";
    }

    renderTiendaNubeLogo() {
        return <img alt="Tiendanube" src={this.getImage()} height={30} width={30} hspace={10} vspace={10}/>
    }
}

export const TiendaNubeConnectButton = withTranslation()(TiendaNubeConnectButtonClass);

